import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "./style";

const PendingApproval = () => {
  const { t } = useTranslation();
  return (
    <>
      <br />
      <br />
      <Container>
        <h3>{t("requestPendingApproval") + " " + t("notificationMessage")}</h3>
      </Container>
    </>
  );
};

export default PendingApproval;
